import React, { useState } from 'react';
import Carousel1 from './carousel1';
import './home.css';
import Carousel2 from './carousel2';
import Footer from './footer';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../loginComponent/login';

export default function Home(){
    const Navigate = useNavigate();

    return <>
    <Carousel1  img1="https://assets.ajio.com/cms/AJIO/WEB/D-UHP-Topbanner-5090-1024x1200.gif"
     img2="https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Main-P2-DennislingoVeroModa-Min60extraupto35.jpg"
     img3 = "https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Main-P5-DNMXNetplay-Upto70.jpg"
     img4 = "https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Main-P6-SuperdryMns-Min3-extra35.jpg"
    />

    <Carousel2 
     img1="https://assets.ajio.com/cms/AJIO/WEB/07042023-D-UHP-BankOffers-5Prepaid.jpg"
     img2 = "https://assets.ajio.com/cms/AJIO/WEB/Paytm_1440x128-without%20CTA%202.jpg"
     img3="https://assets.ajio.com/cms/AJIO/WEB/Mobikwik_1440x128-0.jpg"
    />

    
     <img src="https://assets.ajio.com/cms/AJIO/WEB/07042023-D-UHP-Topbanner-SectionHeader.jpg"  className="homeHeading" alt="" />
     
     <Carousel1  img1="https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Top-P1-NikePuma-Upto40.jpg"
     img2="https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Top-P5-PolaroidEKND-Min60.jpg"
     img3 = "https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Top-P3-TSPerformax-Starting299.jpg"
     img4 = "https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Top-P7-AvaasaDnmx-Under499.jpg"
    />
    
    <img src="https://assets.ajio.com/cms/AJIO/WEB/D-UHP-FeatureCollection-SectionHeader.jpg" className="homeHeading2" alt="" />
     <img src="https://assets.ajio.com/cms/AJIO/WEB/UHP-encrustd-banner-1440x470-revised.gif" className="homeImage1" alt="" />

     <img src="https://assets.ajio.com/cms/AJIO/WEB/07042023-D-UHP-SpotonStyles-Sectionheader.jpg"  className="homeHeading" alt="" />

     <Carousel1  img1="https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Daily-P1-IVocMissChase-Flat50extra30.jpg"
     img2="https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Daily-P3-Purvaja-Upto75.jpg"
     img3 = "https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Daily-P5-Janasya-Upto80.jpg"
     img4 = "https://assets.ajio.com/cms/AJIO/WEB/09042023-UHP-D-Daily-P7-VanHeusen-min40-.jpg"
    />

    <img src="https://assets.ajio.com/cms/AJIO/WEB/07042023-D-UHP-stores-header.jpg" className="homeHeading" alt="" />
    <img src="https://assets.ajio.com/cms/AJIO/WEB/07042023-D-UHP-stores-AJIOGold.jpg" className="homeImage2 sec" alt="" />
    <img src="https://assets.ajio.com/cms/AJIO/WEB/08-04-2023-Discover%20Online%20Stores%20(D).jpg" className="homeImage2" alt="" />
    <img src="https://assets.ajio.com/cms/AJIO/WEB/13102020-D-unisex-ajiocares-strip.jpg" className="homeHeading" alt="" />

    <ul className='homeFlex' type="none">
        <div>
      <li className='homeIcon'><i class="fa-solid fa-camera-rotate"></i></li>
      <li><h4>EASY EXCHANGE</h4></li>
      </div>
      <div>
      <li className='homeIcon'><i class="fa-solid fa-hand-holding-heart"></i></li>
      <li><h4>100% HANDPICKED</h4></li>
      </div>
      <div>
      <li className='homeIcon'><i class="fa-sharp fa-solid fa-circle-check"></i></li>
      <li><h4>ASSURED QUALITY</h4></li>
      </div>
    </ul>
    

     <Footer />

    </>
}